import React from 'react';
import { View, Text, Link } from '@react-pdf/renderer';
import { ATSResumeJson } from '@/types/resume';
import { styles } from '@/components/common/AtsResumePdfStyles';
import { parseRichText, getValidUrl } from './PdfUtils';

interface PdfExperienceProps {
  data: ATSResumeJson;
  showChanges: boolean;
}

export const PdfExperience = React.memo<PdfExperienceProps>(({ data, showChanges }) => {
  if (!data.experience || data.experience.length === 0) return null;

  return (
    <View style={styles.section}>
      <Text style={styles.sectionTitle}>Experience</Text>
      <View style={styles.sectionUnderline} />
      {data.experience.map((exp, idx) => (
        <View key={idx} style={styles.experienceItem}>
          <View wrap={false}>
            <View style={styles.experienceHeader}>
              <Text style={styles.jobTitle}>
                {parseRichText(exp.title, showChanges)}
                {exp.company && (
                  <Text style={styles.companyName}>
                    {' | '}
                    {getValidUrl((exp as any).companyUrl) ? (
                      <Link src={getValidUrl((exp as any).companyUrl)!} style={styles.link}>
                        {parseRichText(exp.company, showChanges)}
                      </Link>
                    ) : (
                      parseRichText(exp.company, showChanges)
                    )}
                  </Text>
                )}
              </Text>
            </View>
            <Text style={styles.jobMeta}>
              {parseRichText(`${exp.startDate} – ${exp.endDate || 'Present'} ${exp.location ? `| ${exp.location}` : ''}`, showChanges)}
            </Text>
            {exp.highlights && exp.highlights.flatMap(h => h.split('\n')).map(h => h.replace(/^[-\s•]+/, '').trim()).filter(h => h.replace(/^[\W\s]+$/, '').length > 0).slice(0, 1).map((highlight, hIdx) => (
              <View key={`first-${hIdx}`} style={styles.bulletRow} wrap={false}>
                <Text style={styles.bulletPoint}>•</Text>
                <Text style={styles.bulletText}>{parseRichText(highlight, showChanges)}</Text>
              </View>
            ))}
          </View>
          {exp.highlights && exp.highlights.flatMap(h => h.split('\n')).map(h => h.replace(/^[-\s•]+/, '').trim()).filter(h => h.replace(/^[\W\s]+$/, '').length > 0).slice(1).map((highlight, hIdx) => (
            <View key={`rest-${hIdx}`} style={styles.bulletRow} wrap={false}>
              <Text style={styles.bulletPoint}>•</Text>
              <Text style={styles.bulletText}>{parseRichText(highlight, showChanges)}</Text>
            </View>
          ))}
        </View>
      ))}
    </View>
  );
});
